<script>
    import { fade } from 'svelte/transition';
</script>

<section>
    <slot></slot>
</section>
